var _circle, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKakao = function SvgKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FBE603"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kakao_svg__clip0_355_290)",
    fill: "#493433"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.023 23.738h1.8l-.9-2.51-.9 2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10C15.941 10 9 15.394 9 22.048c0 4.136 2.682 7.783 6.764 9.954-.232.813-1.061 3.317-2.931 5.058 0 0-.354.381-.464.476 0 0-.673.507.24.461 0 0 3.225-.92 4.654-1.713 0 0 3.54-1.687 4.35-2.397.936.137 1.901.209 2.887.209 8.562 0 15.5-5.394 15.5-12.048S33.062 10 24.5 10Zm-8.18 10.61v5.43a.83.83 0 0 1-.834.826.83.83 0 0 1-.835-.825V20.61h-1.432c-.485 0-.879-.361-.879-.802 0-.441.394-.802.879-.802h4.444c.485 0 .879.36.879.802 0 .441-.395.802-.879.802h-1.345.003Zm7.478 6.224a.827.827 0 0 1-1.046-.512l-.351-.98h-2.952l-.362 1.008a.833.833 0 0 1-1.047.519.815.815 0 0 1-.484-1.054l2.27-6.337a.951.951 0 0 1 .113-.214c.183-.358.557-.602.992-.602.47 0 .873.29 1.035.699.023.04.043.083.06.129l2.26 6.296c.153.43-.064.9-.488 1.048Zm4.953-.011h-2.996a.744.744 0 0 1-.748-.74v-6.258a.83.83 0 0 1 .835-.825.83.83 0 0 1 .835.825v5.517h2.076c.412 0 .748.332.748.739a.745.745 0 0 1-.748.739l-.003.003Zm6.758-.063c-.377.263-.847.246-1.05-.037l-2.154-3.005-.623.63v1.656a.83.83 0 0 1-.835.825.83.83 0 0 1-.835-.825V19.83a.83.83 0 0 1 .835-.825.83.83 0 0 1 .835.825v2.163l2.69-2.713c.293-.295.798-.278 1.128.043.33.318.357.816.064 1.111l-2.073 2.088 2.331 3.252c.203.283.064.727-.313.99v-.005Z"
  }))));
};

export default SvgKakao;